import * as semver from 'semver'

// From v2.12.0 on, 1155 tokens should mint against the Zora Mints Sale Strategy contract
export const contractSupportsZoraTimedSaleStrategy = (
  contractVersion?: string | null,
  contractStandard?: 'ERC721' | 'ERC1155'
) => {
  if (!contractStandard || !contractVersion) {
    return false
  }

  // Try force-convert version format to semver format
  const semVerContractVersion = semver.coerce(contractVersion)?.raw
  if (!semVerContractVersion) return false

  if (contractStandard === 'ERC1155') {
    return semver.gte(semVerContractVersion, '2.12.0')
  } else {
    // 721s use the hardcoded mint fee
    return false
  }
}
